import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Subject } from "rxjs";
import { Route, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ManageOrderderService {

  url: any = environment.API_URL;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private route: Router
  ) { }


  getUpcomingOrders() {
    return this.http.get(this.url + 'club/getUpcomingOrders');
  }

  getUpcomingOrderscurrentDate(data: any) {
    return this.http.get(this.url + 'club/getUpcomingOrders?currentDate=' + data);
}

  getUpcomingOrdersCoach(data: any) {
    return this.http.post(this.url + `club/getUpcomingOrders`, data);
  }


  getDeliveredOrders() {
    return this.http.get(this.url + 'club/getDeliveredOrders');
  }
}
